import AuthenticationService from "service/auth/AuthenticationService";
import EnvironmentService from "service/environment/EnvironmentService";
import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

class UpdateTrackingService {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }

  getDataTables(onResponse, onError) {
    let url = APIConfig.detailedAssessment.getDataTables;
    return this.apiService.get(url, onResponse, onError);
  }

  //   update(flag, patientid, daId, detailedAssessment, onResponse, onError) {
  //     let url = APIConfig.detailedAssessment.update.format(patientid, daId, flag);
  //     return this.apiService.put(url, detailedAssessment, onResponse, onError);
  //   }

  //   getDataAssissment(patientid, userid, onResponse, onError) {
  //     let url = APIConfig.detailedAssessment.getDataAssissment.format(
  //       patientid,
  //       userid
  //     );

  //     return this.apiService.get(url, onResponse, onError);
  //   }

  getAuto(text, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getIcd.format(text);

    return this.apiService.get(url, onResponse, onError);
  }

  getSurgeries(text, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getSurgeries.format(text);
    return this.apiService.get(url, onResponse, onError);
  }

  getMedicines(text, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getMedicines.format(text);

    return this.apiService.get(url, onResponse, onError);
  }

  getSubTestData(LabtestId, SubLabTestId, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getSubTestData.format(
      LabtestId,
      SubLabTestId
    );

    return this.apiService.get(url, onResponse, onError);
  }

  getSynonyms(subTest, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getSynonyms.format(subTest);
    return this.apiService.get(url, onResponse, onError);
  }

  handleSaveSynonyms(payload, onResponse, onError) {
    let url = APIConfig.detailedAssessment.handleSaveSynonyms;
    return this.apiService.post(url, payload, onResponse, onError);
  }

  updateZohoCC(ele, index, onResponse, onError) {
    let url = APIConfig.tracking.chiefComplaint.zohoUpdate;
    this.apiService.put(url, ele, onResponse, onError);
  }

  addZohoCC(ele, index, onResponse, onError) {
    let url = APIConfig.tracking.chiefComplaint.zohoAdd;
    this.apiService.post(url, ele, onResponse, onError);
  }

  getUsersByProject(projectId, onResponse, onError) {
    let url = APIConfig.tracking.chiefComplaint.userByProject.format(projectId);
    return this.apiService.get(url, onResponse, onError);
  }

  addChiefComplaint(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.chiefComplaint.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  addSurgeries(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.surgery.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  addMedicines(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.medicine.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  addLabTest(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.labtest.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  updateLabTest(payload, patientid, trackingId, onResponse, onError) {
    let url = APIConfig.tracking.labtest.update.format(patientid, trackingId);
    this.apiService.put(url, payload, onResponse, onError);
  }

  getLabTestForDocId(body, patientid, onResponse, onError) {
    let url = APIConfig.tracking.labtest.searchByDocId.format(patientid);
    this.apiService.post(url, body, onResponse, onError);
  }

  getCount(patientid, onResponse, onError) {
    let url = APIConfig.tracking.labtest.get.format(patientid);

    return this.apiService.get(url, onResponse, onError);
  }

  addDiagnosis(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.diagnosis.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  addAddictions(payload, patientid, onResponse, onError) {
    let url = APIConfig.tracking.addictions.add.format(patientid);
    this.apiService.post(url, payload, onResponse, onError);
  }

  getLabTest(text, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getLabTest.format(text);

    return this.apiService.get(
      url,
      (response) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error) => {
        onResponse([]);
      }
    );
  }

  getSubTest(LabtestId, text, onResponse, onError) {
    let url = APIConfig.detailedAssessment.getSubTest.format(LabtestId, text);

    return this.apiService.get(
      url,
      (response) => {
        if (response) {
          onResponse(response);
        } else {
          onResponse([]);
        }
      },
      (error) => {
        onResponse([]);
      }
    );
  }
  digitiseNow = (body, onResponse, onError) => {
    let url = APIConfig.documentDigitisation.digitiseNow;
    return this.apiService.post(url, body, onResponse, onError);
  };
}

export default UpdateTrackingService;
